import type { RouteRecordRaw } from 'vue-router'
import { countriesRoutes } from './countries/countriesRoute'
import { marketsRoutes } from './markets/marketsRoute'
import { marketCountriesRoutes } from './marketCountries/marketCountriesRoute'
import { mediaCategoriesRoutes } from './mediaCategories/mediaCategoriesRoute'
import { amenitiesRoutes } from './amenities/amenitiesRoute'
import { highlightTemplatesRoutes } from './highlightTemplates/highlightTemplatesRoute'
import { propertyTypesRoutes } from './propertyTypes/propertyTypesRoute'
import { agreementTemplatesRoutes } from './agreementTemplates/agreementTemplatesRoute'

export const mastersRoutes: RouteRecordRaw[] = [
  ...countriesRoutes,
  ...marketsRoutes,
  ...marketCountriesRoutes,
  ...mediaCategoriesRoutes,
  ...amenitiesRoutes,
  ...highlightTemplatesRoutes,
  ...propertyTypesRoutes,
  ...agreementTemplatesRoutes,
]
